export const routePaths = {
  home: "/",
  calculations: "/calculations",
  calculationAnalysis: "/calculation-analysis",
  operationalData: "/operational-data",
} as const;

export const routeSegments = {
  calculations: "calculations",
  calculationDetail: "calculations/:calculationId",
  calculationAnalysis: "calculation-analysis",
  operationalData: "operational-data",
} as const;

export const calculationDetailPath = (calculationId: string): string =>
  `${routePaths.calculations}/${calculationId}`;
